module.exports = __webpack_public_path__ + "static/mac-a18f001e8ebb3829718369075992b41b.png";